import axios from '../axios';

/**
 * 目录列表
 * 
 * @url /document/index
 * 
 */

export function documentloade(params) {
    return axios.post('/document/index', params)
}
/**
 * 获取分类及分类文件
 * 
 * @url /document/index
 * 
 */

export function documentindex(params) {
    return axios.post('/document/index', params)
}
/**
 * 创建文件夹
 * 
 * @url /document/mkdir
 * 
 */

export function documentmkdir(params) {
    return axios.post('/document/mkdir', params)
}
/**
 * 文件夹改名
 * 
 * @url /document/rename
 * 
 */

export function documentrename(params) {
    return axios.post('/document/rename', params)
}
/**
 * 文件夹改名
 * 
 * @url /document/file_rename
 * 
 */

export function documentfilerename(params) {
    return axios.post('/document/file_rename', params)
}
/**
 * 删除文件
 * 
 * @url /document/delete
 * 
 */

export function documentdelete(params) {
    return axios.post('/document/erase', params)
}
/**
 * 文件移动
 * 
 * @url /document/move
 * 
 */

export function documentmove(params) {
    return axios.post('/document/move', params)
}

/**
 * 原创认证
 * 
 * @url /document/identification
 * 
 */

export function documentidentification(params) {
    return axios.post('/document/identification', params)
}
/**
 * 文件列表
 * 
 * @url /document/list
 * 
 */

export function documentlist(params) {
    return axios.post('/document/list', params)
}
/**
 * 文件上传
 * 
 * @url /document/uploader
 * 
 */

export function documentuploader(params) {
    return axios.post('/document/uploader', params, {

    })
}
/**
 * 获取首页轮播图片
 * 
 * @url /system/banner
 * 
 */

export function systembanner(params) {
    return axios.post('/system/banner', params, {

    })
}
/**
 * 企业绑定人员列表
 * 
 * @url /bind/staff_list
 * 
 */

export function bindstafflist(params) {
    return axios.post('/bind/staff_list', params, {

    })
}
/**
 * 为企业绑定人员
 * 
 * @url /bind/add_staff
 * 
 */

export function bindaddstaff(params) {
    return axios.post('/bind/add_staff', params, {

    })
}
/**
 * 根据手机号查询用户
 * 
 * @url /auth/search
 * 
 */

export function authSearchs(params) {
    return axios.post('/auth/search', params)
}



/**
 * 个人中心取消绑定企业
 * 
 * @url /bind/quit
 * 
 */

export function bindquit(params) {
    return axios.post('/bind/quit', params)
}
/**
 * 移除人员
 * 
 * @url /bind/remove
 * 
 */

export function bindremove(params) {
    return axios.post('/bind/remove', params)
}
/**
 * 切换角色
 * 
 * @url /bind/change_role
 * 
 */

export function bindchangerole(params) {
    return axios.post('/bind/change_role', params)
}
/**
 * 文档权限查看
 * 
 * @url /document/user_permission
 * 
 */

export function documentuserpermission(params) {
    return axios.post('/document/user_permission', params)
}
/**
 * 文档权限配置
 * 
 * @url /document/permission
 * 
 */

export function documentpermission(params) {
    return axios.post('/document/permission', params)
}

/**
 * 分页获取我的分享
 * 
 * @url /file_share/my_share
 * 
 */

export function filesharemyshare(params) {
    return axios.post('/file_share/my_share', params)
}
/**
 * 分页获取分享给我的文件
 * 
 * @url /file_share/my_receive
 * 
 */

export function filesharemyreceive(params) {
    return axios.post('/file_share/my_receive', params)
}
/**
 * 分享文件
 * 
 * @url /file_share/share
 * 
 */

export function fileshareshare(params) {
    return axios.post('/file_share/share', params)
}
/**
 * 取消分享
 * 
 * @url /file_share/del
 * 
 */

export function filesharedel(params) {
    return axios.post('/file_share/del', params)
}
/**
 * 接收文件
 * 
 * @url /file_share/receive
 * 
 */

export function filesharereceive(params) {
    return axios.post('/file_share/receive', params)
}
/**
 * 研发任务管理-分页获取任务
 * 
 * @url /project_task/index
 * 
 */

export function projecttaskindex(params) {
    return axios.post('/project_task/index', params)
}
/**
 * 研发任务管理-删除任务
 * 
 * @url /project_task/del
 * 
 */

export function projecttaskdel(params) {
    return axios.post('/project_task/del', params)
}
/**
 * 研发任务管理-新增任务
 * 
 * @url /project_task/save
 * 
 */

export function projecttasksave(params) {
    return axios.post('/project_task/save', params)
}

/**
 * 研发任务管理-修改任务
 * 
 * @url /project_task/update
 * 
 */

export function projecttaskupdate(params) {
    return axios.post('/project_task/update', params)
}
/**
 * 研发任务管理-创建连接
 * 
 * @url /project_task_link/save
 * 
 */

export function projecttasklinksave(params) {
    return axios.post('/project_task_link/save', params)
}
/**
 * 研发任务管理-删除连接
 * 
 * @url /project_task_link/del
 * 
 */

export function projecttasklinkdel(params) {
    return axios.post('/project_task_link/del', params)
}
/**
 * 研发任务管理-根据项目id查询任务
 * 
 * @url /project_task/find

 * 
 */

export function projecttaskfind(params) {
    return axios.post('/project_task/find', params)
}
/**
 * 研发任务管理-详情
 * 
 * @url /project_task/detail

 * 
 */

export function projecttaskdetail(params) {
    return axios.post('/project_task/detail', params)
}
/**
 * 研发任务管理-详情附件删除
 * 
 * @url /project_task/remove_file

 * 
 */

export function projecttaskremovefile(params) {
    return axios.post('/project_task/remove_file', params)
}
/**
 * 研发任务管理
 * 
 * @url /project_task/modify_target

 * 
 */

export function projecttaskmodifytarget(params) {
    return axios.post('/project_task/modify_target', params)
}


/**
 * 批准立项
 * 
 * @url /ent_tech_research_development/approval
 * 
 */

export function enttechresearchdevelopmentapproval(params) {
    return axios.post('/ent_tech_research_development/approval', params)
}

/**
 * 批准结项
 * 
 * @url /ent_tech_research_development/finish
 * 
 */

export function enttechresearchdevelopmentfinish(params) {
    return axios.post('/ent_tech_research_development/finish', params)
}
/**
 * 批准结项
 * 
 * @url /ent_tech_research_development/apply_finish
 * 
 */

export function enttechresearchdevelopmentapplyfinish(params) {
    return axios.post('/ent_tech_research_development/apply_finish', params)
}
/**
 * 协同人员资料编辑
 * 
 * @url /bind/edit_staff
 * 
 */

export function bindeditstaff(params) {
    return axios.post('/bind/edit_staff', params)
}

/**
 * 获取组织架构
 * 
 * @url /eos/index
 * 
 */

export function eosindex(params) {
    return axios.post('/eos/index', params)
}
/**
 * 新增部门
 * 
 * @url /eos/save
 * 
 */

export function eossave(params) {
    return axios.post('/eos/save', params)
}
/**
 * 删除部门
 * 
 * @url /eos/del
 * 
 */

export function eosdel(params) {
    return axios.post('/eos/del', params)
}
/**
 * 排序
 * 
 * @url /eos/update
 * 
 */

export function eosupdate(params) {
    return axios.post('/eos/update', params)
}

/**
 * 根据部门ID获取员工
 * 
 * @url /eos/staff
 * 
 */

export function eosstaff(params) {
    return axios.post('/eos/staff', params)
}
/**
 * 将用户加入指定部门
 * 
 * @url /eos/join
 * 
 */

export function eosjoin(params) {
    return axios.post('/eos/join', params)
}